import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "prettifyUnderscoredValues",
  standalone: false,
})
export class PrettifyUnderscoredValuesPipe implements PipeTransform {
  transform(str: string): string {
    if (!str) return;

    str = str.replace(/_/g, " ");
    const splitStr = str.toLowerCase().split(" ");
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }

    return splitStr.join(" ");
  }
}
